
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzSizeLDSType } from 'ng-zorro-antd/core/types';
import { NzInputModule } from 'ng-zorro-antd/input';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
    imports: [NzInputModule, FormsModule]
})
export class SearchBarComponent implements OnInit {
    @Input() onQueryChange: Subject<string> = new Subject<string>();
    @Input() onQueryReset: Subject<string> = new Subject<string>();
    @Input() searchByTyping = false;
    @Input() debounceTime = 500;
    @Input() placeholder = '';
    @Input() nzSize: NzSizeLDSType = 'default';

    @Input() queryString: string;
    @Output() queryStringChange: EventEmitter<string> = new EventEmitter<string>();

    queryStringChangedSubject: Subject<string> = new Subject<string>();

    ngOnInit() {
        this.queryStringChangedSubject.pipe(debounceTime(this.debounceTime)).subscribe(event => {
            this.onQueryChange.next(event);
        });
    }

    resetSearch() {
        this.queryString = '';
        this.queryStringChange.emit(this.queryString);
        this.onQueryChange.next('');
        this.onQueryReset.next(null);
    }

    onEnter($event: any) {
        // send new event when enter
        if (!this.searchByTyping) {
            this.onQueryChange.next(this.queryString);
        }
    }

    queryStringChanged($event: string): void {
        if (this.searchByTyping) {
            this.queryStringChangedSubject.next($event);
        }
        this.queryStringChange.emit(this.queryString);
    }
}
